import { NgModule } from "@angular/core";
import { FormsModule } from '@angular/forms';
import { CommonModule } from "@angular/common";
import { RouterModule } from '@angular/router';


import { SignInComponent } from "./sign-in.component";

@NgModule({
    declarations: [
      SignInComponent
    ],
    imports: [
      FormsModule,
      CommonModule,
      RouterModule
    ],
    providers: [
    ]
})
export class SignInModule { }



// WEBPACK FOOTER //
// /app/SPA/src/app/account/sign-in/sign-in.module.ts